const areAddressesEqual = (a, b) => a.toLowerCase() === b.toLowerCase();
export default areAddressesEqual;